import { AddBoxOutlined, HighlightOffOutlined } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import SelectFromSilo from '../../../../../MySections/DTechComps/SelectFromSilo';
import SelectImgComp from '../../../../../MySections/ImagesSetter/SelectImgComp';
import EraseCheck from '../../../../../MySections/PopUps/EraseCheck';
import InputSet from '../../../../../MySections/PopUps/InputSet';
import AccordProdNumInput from './AccordProdNumInput';
import AccordProdOptions from './AccordProdOptions';
import AccordProdTextArea from './AccordProdTextArea';
import AccordProdTextInput from './AccordProdTextInput';
import AcoordBtns from './AcoordBtns';

// פונקציית עזר: מוציאה איבר ממקום אחד במערך, מכניסה למקום אחר
function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

const AccordProd = (props) => {
  const { divisionIndex, produc, productsLength, theMenu, proIndex } = props;
  // divisionIndex - כדי לדעת באיזו מחלקה אנחנו
  // produc - אובייקט המוצר (מכיל _id)
  // theMenu - כל המבנה BuisMenu

  const [buisMenu, setBuisMenu] = useState(theMenu);
  const [thePopUp, setThePopUp] = useState("");
  const [diag, setDiag] = useState("");
  let optis = "";

  useEffect(() => {
    // בכל פעם שהורה מעדכן את theMenu, נרענן את ה-buisMenu המקומי
    setBuisMenu(theMenu);
  }, [theMenu]);

  // ====================================================================
  // פונקציה כללית לעדכן מוצר ב-buisMenu לפי divisionIndex ו-_id של המוצר
  // ====================================================================
  const updateProductField = (fieldName, newValue) => {
    let tempMnu = [...buisMenu];
    // מוצאים את המוצר הנכון לפי _id
    const prodIndex = tempMnu[divisionIndex].Products.findIndex(
      (p) => p._id === produc._id
    );
    if (prodIndex >= 0) {
      tempMnu[divisionIndex].Products[prodIndex] = {
        ...tempMnu[divisionIndex].Products[prodIndex],
        [fieldName]: newValue
      };

      props.UpdateTheBuis(tempMnu);
    }
  };

  // ====================================================================
  // שינויים ספציפיים
  // ====================================================================
  const changeProdName = (newValue) => {
    updateProductField("prodName", newValue);
  };
  const changeProdSmallText = (newValue) => {
    updateProductField("prodSmallText", newValue);
  };
  const changeProdPrice = (newValue) => {
    updateProductField("prodPrice", newValue);
  };
  const changeProdRemarks = (newValue) => {
    updateProductField("prodRemarks", newValue);
  };
  const changeProdSEOdescription = (newValue) => {
    updateProductField("prodSEOdescription", newValue);
  };
  const changeProdProducts = (newValue) => {
    updateProductField("prodProducts", newValue);
  };
  const changeProdProperties = (newValue) => {
    updateProductField("prodProperties", newValue);
  };
  const changeCashRegMakat = (newValue) => {
    updateProductField("cashRegMakat", newValue);
  };

  const setProdMainImg = (fUrl) => {
    updateProductField("prodImageUrl", fUrl);
  };

  // ====================================================================
  // יצירת נלווים
  // ====================================================================
  const createNewOption = () => {
    setThePopUp(
      <InputSet
        Title="הוספת נלווה"
        ContentText="שם נלווה"
        inLabel=""
        okClick={(textBack) => createOptionOK(textBack)}
        cancelClick={() => setThePopUp("")}
        errorMsg="על מנת ליצור נלווה חדש, חובה לתת לו שם."
      />
    );
  };
  const createOptionOK = (textBack) => {
    let tempMnu = [...buisMenu];
    const prodIndex = tempMnu[divisionIndex].Products.findIndex((p) => p._id === produc._id);
    if (prodIndex >= 0) {
      let newOption = {
        optionName: textBack,
        optionBtnTxt: "",
        allowMulti: false,
        selected: 0,
        mustSelect: false,
        options: []
      };
      tempMnu[divisionIndex].Products[prodIndex].prodOptions.push(newOption);
      props.UpdateTheBuis(tempMnu);
    }
    setThePopUp("");
  };

  const getDetOpFromSilo = () => {
    setDiag(
      <Dialog onClose={() => setDiag("")} open={true} className="popUpWrapMedia">
        <div className="inDiag">
          <HighlightOffOutlined
            sx={{ fontSize: 40 }}
            className="pointing closeDiagBtn"
            onClick={() => setDiag("")}
          />
          <SelectFromSilo
            setTheList={(theSilo) => {
              createMultiOptions(theSilo);
              setDiag("");
            }}
            handleClose={() => setDiag("")}
          />
        </div>
      </Dialog>
    );
  };

  const createMultiOptions = (theSilo) => {
    let tempMnu = [...buisMenu];
    const prodIndex = tempMnu[divisionIndex].Products.findIndex((p) => p._id === produc._id);
    if (prodIndex >= 0) {
      let allFromSilo = theSilo.map((item) => {
        return {
          optionName: item.optionName,
          optionBtnTxt: item.optionBtnTxt,
          allowMulti: item.allowMulti,
          selected: item.selected,
          mustSelect: item.mustSelect,
          options: item.options
        };
      });
      allFromSilo.forEach((element) => {
        tempMnu[divisionIndex].Products[prodIndex].prodOptions.push(element);
      });
      props.UpdateTheBuis(tempMnu);
    }
  };

  // ====================================================================
  // הסרת מוצר
  // ====================================================================
  const removeProd = () => {
    setThePopUp(
      <EraseCheck
        title="האם בטוח למחוק את המוצר?"
        sucecssFunc={() => removeProduct()}
      />
    );
  };
  const removeProduct = () => {
    let tempMnu = [...buisMenu];
    const prodIndex = tempMnu[divisionIndex].Products.findIndex((p) => p._id === produc._id);
    if (prodIndex >= 0) {
      tempMnu[divisionIndex].Products.splice(prodIndex, 1);
      props.UpdateTheBuis(tempMnu);
    }
  };

  // ====================================================================
  // הזזת מוצר למעלה/למטה (לא קשור ל-dnd בין מחלקות)
  // ====================================================================
  const setUpProd = () => {
    let tempMnu = [...buisMenu];
    let arr = tempMnu[divisionIndex].Products;
    const oldIndex = arr.findIndex((p) => p._id === produc._id);
    if (oldIndex > 0) {
      let newArr = array_move([...arr], oldIndex, oldIndex - 1);
      tempMnu[divisionIndex].Products = newArr;
      props.UpdateTheBuis(tempMnu);
    }
  };
  const setDownProd = () => {
    let tempMnu = [...buisMenu];
    let arr = tempMnu[divisionIndex].Products;
    const oldIndex = arr.findIndex((p) => p._id === produc._id);
    if (oldIndex >= 0 && oldIndex < arr.length - 1) {
      let newArr = array_move([...arr], oldIndex, oldIndex + 1);
      tempMnu[divisionIndex].Products = newArr;
      props.UpdateTheBuis(tempMnu);
    }
  };

  const setInStock = () => {
    let tempMnu = [...buisMenu];
    const prodIndex = tempMnu[divisionIndex].Products.findIndex((p) => p._id === produc._id);
    if (prodIndex >= 0) {
      let curr = tempMnu[divisionIndex].Products[prodIndex];
      curr.inStock = !curr.inStock;
      tempMnu[divisionIndex].Products[prodIndex] = curr;
      props.UpdateTheBuis(tempMnu);
    }
  };

  const setOkToDeliver = () => {
    let tempMnu = [...buisMenu];
    const prodIndex = tempMnu[divisionIndex].Products.findIndex((p) => p._id === produc._id);
    if (prodIndex >= 0) {
      let curr = tempMnu[divisionIndex].Products[prodIndex];
      curr.okToDeliver = !curr.okToDeliver;
      tempMnu[divisionIndex].Products[prodIndex] = curr;
      props.UpdateTheBuis(tempMnu);
    }
  };

  // להרכיב טקסט של כל הנלוויים
  if (produc.prodOptions?.length) {
    optis = produc.prodOptions.map((x) => x.optionName).join(", ");
  }

  //   const prodcounter = 9999; // רק כדי לתת EventKey באקורדיון, אם צריך מספר
  const productEventKey = `product-${divisionIndex}-${produc._id}`;
  return (
    <Card className={"inAccord"}>
      <Accordion.Collapse className="collapseparent" eventKey={productEventKey}>
        <Card.Body>
          <div className="prod">
            <div className="col-md-12 fullRow">
              {/* שם מוצר */}
              <AccordProdTextInput
                clss="col-md-9 prodFirst onRight theFrow"
                headI="שם המוצר"
                prodTxtVal={produc.prodName}
                setProdItm={(index, proIndex, val) => changeProdName(val)}
              />
              {/* כותרת בנוגע למוצר */}
              <AccordProdTextInput
                clss="col-md-9 prodFirst onRight theFrow"
                headI="כותרת בנוגע למוצר"
                prodTxtVal={produc.prodSmallText || ""}
                setProdItm={(index, proIndex, val) => changeProdSmallText(val)}
              />
              {/* פירוט המוצר */}
              <AccordProdTextArea
                clss="col-md-8 prodFirst onRight theFrow"
                headI="פירוט המוצר"
                prodTxtVal={produc.prodProducts || ""}
                setProdItm={(index, proIndex, val) => changeProdProducts(val)}
              />

              {/* תמונת מוצר */}
              <div className="prodFirst col-md-2 onLeft">
                <SelectImgComp
                  imgCss="medImgDisp pointing"
                  firstImgToDisp={produc.prodImageUrl || ""}
                  theFunction={(fUrl) => setProdMainImg(fUrl)}
                />
              </div>

              {/* מחיר */}
              <AccordProdNumInput
                clss="col-md-9 prodFirst onRight theFrow"
                headI="מחיר"
                prodTxtVal={produc.prodPrice}
                setProdItm={(index, proIndex, val) => changeProdPrice(val)}
              />

              {/* הערות */}
              <AccordProdTextInput
                clss="col-md-9 prodFirst onRight theFrow"
                headI="הערות"
                prodTxtVal={produc.prodRemarks || ""}
                setProdItm={(index, proIndex, val) => changeProdRemarks(val)}
              />

              {/* מאפיינים נוספים */}
              <AccordProdTextInput
                clss="col-md-9 prodFirst onRight theFrow"
                headI="מאפיינים נוספים"
                prodTxtVal={produc.prodProperties || ""}
                setProdItm={(index, proIndex, val) => changeProdProperties(val)}
              />

              {/* תיאור SEO */}
              <AccordProdTextInput
                clss="col-md-9 prodFirst onRight theFrow"
                headI="תיאור SEO"
                prodTxtVal={produc.prodSEOdescription || ""}
                setProdItm={(index, proIndex, val) => changeProdSEOdescription(val)}
              />

              {/* מקט לקופה */}
              <AccordProdTextInput
                clss="col-md-9 prodFirst onRight theFrow"
                headI="מקט לקופה"
                prodTxtVal={produc.cashRegMakat || ""}
                setProdItm={(index, proIndex, val) => changeCashRegMakat(val)}
              />
            </div>

            {/* נלווים */}
            <div className="prodOptsWrap">
              <Accordion defaultActiveKey="0" className="has-gap ms-accordion-chevron menuSectionsAcord">
                <Card>
                  <Accordion.Collapse className="collapseparent" eventKey={`Pr${productEventKey}`}>
                    <Card.Body>
                      <Accordion defaultActiveKey="0" className="has-gap ms-accordion-chevron menuSectionsAcord">
                        <Button
                          variant="contained"
                          className="addDivBtn"
                          onClick={() => createNewOption()}
                          startIcon={<AddBoxOutlined style={{ color: 'white' }} />}
                        >
                          הוסף נלווה
                        </Button>
                        &nbsp;
                        <Button
                          variant="contained"
                          className="addDivBtn"
                          onClick={() => getDetOpFromSilo()}
                          startIcon={<AddBoxOutlined style={{ color: 'white' }} />}
                        >
                          נלווה ממאגר
                        </Button>
                        <br />
                        <br />
                        {produc.prodOptions?.map((prodOpt, OptINdex) => {
                          // כאן אפשר למפות את הקומפוננטה AccordProdOptions וכו'
                          return (
                            <AccordProdOptions
                              key={OptINdex}
                              prodOpt={prodOpt}
                              index={divisionIndex}
                              productId={produc._id}
                              // ...
                              theMenu={buisMenu}
                              UpdateTheBuis={props.UpdateTheBuis}
                              OptINdex={OptINdex}
                              proIndex={proIndex}
                            />
                          );
                        })}
                      </Accordion>
                    </Card.Body>
                  </Accordion.Collapse>
                  <Accordion.Toggle as={Card.Header} eventKey={`Pr${productEventKey}`}>
                    <span>נלווים</span>
                    <span className="noBoldvSmall"> {optis}</span>
                  </Accordion.Toggle>
                </Card>
              </Accordion>
            </div>
          </div>
        </Card.Body>
      </Accordion.Collapse>

      {/* כותרת האקורדיון */}
      <Accordion.Toggle as={Card.Header} eventKey={productEventKey}>
        <span className="fullRow">
          <span className="onRight">{produc.prodName}&nbsp;</span>
          <span className="onRight">{produc.prodPrice} ₪</span>
        </span>
        <span className="noBoldvSmall">{optis}</span>
      </Accordion.Toggle>

      {/* כפתורים (מחק, למעלה/למטה, inStock וכו') */}
      <AcoordBtns
        cs="acoordBtns"
        index={divisionIndex}
        product={produc}
        productsLength={productsLength}
        removeProd={() => removeProd()}
        setUpProd={() => setUpProd()}
        setDownProd={() => setDownProd()}
        setInStock={() => setInStock()}
        setOkToDeliver={() => setOkToDeliver()}
      />

      {thePopUp}
      {diag}
    </Card>
  );
};

export default AccordProd;
